import React, {
  Dispatch,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { InfoType, ItemTypes, PopupsListType } from "../RightSideMenu";
import loadIco from "../../assets/loading-ico.gif";
import closeIco from "../../assets/close-icon-color.png";
import { earlyWarning } from "../../../mainLayer/earlyWarning/ShowEarlyWarning";
import { hzIncidents } from "../../../mainLayer/hazardIncidentsLayers/IncidentsMenuDropDown";
import { DetailsTypeDataTable } from "../../../mainLayer/summeryComp/detailsSum/DetailTypeDataTable";
import HzTypeDataTable from "../../../mainLayer/summeryComp/detailsSum/HzTypeDataTable";
import SummeryEWS from "../../../mainLayer/summeryComp/SummeryEWS";
import ReportedIncidentsDataTable from "../../../mainLayer/summeryComp/ReportedIncidentsDataTable";
import { map } from "../../../mainLayer/MainLayer";
import Overlay from "ol/Overlay";
import ReactDOM from "react-dom";
import SummeryFull from "../../../mainLayer/summeryComp/SummeryFull";

type SideMenuPopupsType = {
  setWindowState: Dispatch<React.SetStateAction<boolean>>;
  earlyWarningsFull: earlyWarning[];
  hzDatafromSummery: hzIncidents[];
  moreDetailWindow: Dispatch<React.SetStateAction<boolean>>;
  data: InfoType;
  removeItem: (id: string, type: ItemTypes) => void;
  addItem: (id: string, type: ItemTypes) => void;
  onClose: () => void;
};

const SumFull = (props: SideMenuPopupsType) => {
  const handleClosePopupClick = () => {
    props.setWindowState((prevState) => false);
    props.moreDetailWindow(false);
  };

  const [isNotRelease, setIsNotRelease] = useState<boolean>(true);

  const popupRef = useRef<HTMLDivElement | null>(null);
  const popupElement = document.createElement("earlyWarningElement");

  const mouseMoveEvent = useCallback(
    (event: MouseEvent) => {
      const sideMenu = document.getElementById("side-menu-wrapper");

      if (sideMenu && isNotRelease) {
        const sideMenuWidth = Number(
          window.getComputedStyle(sideMenu).left.slice(0, -2)
        );

        if (sideMenuWidth > event.clientX) {
          ReactDOM.render(
            <SummeryFull
              onClose={props.onClose}
              earlyWarningsFromChild={props.earlyWarningsFull}
              hzDatafromSummery={props.hzDatafromSummery}
              addItem={props.addItem}
              id={props.data.id}
            />,
            popupElement
          );

          const overlay = new Overlay({
            element: popupElement,
            autoPan: {
              animation: {
                duration: 250,
              },
            },
          });

          overlay.setPosition([7.873054, 80.771797]);
          map.addOverlay(overlay);
          props.removeItem(props.data.id, "info");
          setIsNotRelease(false);
        }
      }
    },
    [isNotRelease]
  );

  const mouseMoveEventTouch = useCallback(
    (event: TouchEvent) => {
      const sideMenu = document.getElementById("side-menu-wrapper");

      if (sideMenu && isNotRelease) {
        const sideMenuWidth = Number(
          window.getComputedStyle(sideMenu).left.slice(0, -2)
        );

        const touchX = event.touches[0].clientX; // Get touch position
  
        if (sideMenuWidth > touchX) {
          ReactDOM.render(
            <SummeryFull
              onClose={props.onClose}
              earlyWarningsFromChild={props.earlyWarningsFull}
              hzDatafromSummery={props.hzDatafromSummery}
              addItem={props.addItem}
              id={props.data.id}
            />,
            popupElement
          );

          const overlay = new Overlay({
            element: popupElement,
            autoPan: {
              animation: {
                duration: 250,
              },
            },
          });

          overlay.setPosition([7.873054, 80.771797]);
          map.addOverlay(overlay);
          props.removeItem(props.data.id, "info");
          setIsNotRelease(false);
        }
      }
    },
    [isNotRelease]
  );

 useEffect(() => {
      const handleMouseDown = () => {
        document.addEventListener("mousemove", mouseMoveEvent);
        document.addEventListener("mouseup", handleMouseUp);
      };
    
      const handleMouseUp = () => {
        document.removeEventListener("mousemove", mouseMoveEvent);
        document.removeEventListener("mouseup", handleMouseUp);
      };
    
      const handleTouchStart = () => {
        document.addEventListener("touchmove", mouseMoveEventTouch);
        document.addEventListener("touchend", handleTouchEnd);
      };
    
      const handleTouchEnd = () => {
        document.removeEventListener("touchmove", mouseMoveEventTouch);
        document.removeEventListener("touchend", handleTouchEnd);
      };
    
      if (popupRef.current) {
        popupRef.current.addEventListener("mouseenter", () => {
          popupRef.current?.addEventListener("mousedown", handleMouseDown);
          popupRef.current?.addEventListener("touchstart", handleTouchStart);
        });
      }
    
      return () => {
        document.removeEventListener("mousemove", mouseMoveEvent);
        document.removeEventListener("mouseup", handleMouseUp);
        document.removeEventListener("touchmove", mouseMoveEventTouch);
        document.removeEventListener("touchend", handleTouchEnd);
      };
    }, [mouseMoveEvent, mouseMoveEventTouch]);

  return (
    <div className={`popup data-table`} ref={popupRef}>
      <div className={`titleWrapper`}>
        <span>More Information</span>
        <div className={`titleButtonContainer no-drag`}>
          <i className={`titleIcon fullScreenIco`}></i>
          <i
            className={`titleIcon closeIco`}
            onClick={(e) => handleClosePopupClick()}
            onTouchStart={(e) => handleClosePopupClick()}
          ></i>
        </div>
      </div>
      {props.earlyWarningsFull.length !== 0 && (
        <div className={`data-table-wrapper no-drag`}>
          <SummeryEWS earlyWarningsFromChild={props.earlyWarningsFull} />
        </div>
      )}

      {props.hzDatafromSummery.length !== 0 && (
        <div className={`data-table-wrapper no-drag`}>
          <ReportedIncidentsDataTable
            hzDatafromSummery={props.hzDatafromSummery}
          />
        </div>
      )}
    </div>
  );
};

export default SumFull;
